import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Header.module.css";
import { InfoIcon } from "../assets/icons/infoIcon";
import { BackIcon } from "../assets/icons/backIcon";
import { LoginIcon } from "../assets/icons/loginIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  clearUserInfo,
  toggleInfoModal,
  updateLoginInfo,
} from "../slice/userInfoSlice";
import { PREV_ROUTE } from "../Common/Constant";
import Popover from "../CustomComp/Popover/Popover";
import { clearGdInfo } from "../slice/gdInfoSlice";
import MyAxios from "../axios/CustomAxios";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { firstName } = useSelector((state) => state.userInfoSlice);

  useEffect(() => {
    if (!firstName) {
      getUserData();
    }
  }, []);

  const getUserData = () => {
    try {
      MyAxios.get("/users/get-user")
        .then((res) => {
          if (res.data.user) {
            dispatch(updateLoginInfo(res.data.user));
          } else {
            localStorage.removeItem("token");
            onLogOut();
          }
        })
        .catch((err) => {
          console.error(err);
          localStorage.removeItem("token");
          navigate("/login");
        });
    } catch (err) {
      console.error(err);
      localStorage.removeItem("token");
      window?.location?.reload && window.location.reload();
    }
  };

  const onUserbtnClick = () => {};

  const onInfoBtnClick = () => {
    dispatch(toggleInfoModal(true));
  };

  const onLogOut = () => {
    dispatch(clearUserInfo());
    dispatch(clearGdInfo());
    localStorage.removeItem("token");
    navigate("/login");
  };

  const getPopoverButton = () => {
    return firstName ? null : (
      <button
        onClick={onUserbtnClick}
        className={`iconButton headerButtons ${styles.loginIcon}`}
      >
        <LoginIcon />
      </button>
    );
  };

  const getPopoverContent = () => {
    return firstName ? (
      <>
        <div className={styles.row}>
          Hi{" "}
          {firstName.charAt(0).toUpperCase() +
            firstName.slice(1).toLowerCase() +
            " "}
        </div>
        <div className={styles.row}>View Profile</div>
        <div className={styles.row} onClick={onLogOut}>
          Logout
        </div>
      </>
    ) : null;
  };

  const gotoPrevPage = () => {
    navigate(PREV_ROUTE[location?.pathname || ""]);
  };

  return (
    <header className={styles.header}>
      <div className={styles.leftSection}>
        <div className={styles.title} onClick={() => navigate("/home")}>
          GamerzDen
        </div>
      </div>
      {location.pathname !== "/login" && (
        <div className={styles.rightSection}>
          {location.pathname !== "/home" && (
            <button
              className={`iconButton ${styles.backIcon} headerButtons`}
              onClick={gotoPrevPage}
            >
              <BackIcon />
            </button>
          )}
          <button
            className={`iconButton headerButtons`}
            onClick={onInfoBtnClick}
          >
            <InfoIcon />
          </button>

          <Popover
            btnIcon={<LoginIcon />}
            buttonContent={getPopoverButton()}
            popoverContent={getPopoverContent()}
          />
        </div>
      )}
    </header>
  );
};

export default Header;
